import { Box } from "@mui/material";
import { useSyndeticsConfig } from "@tlc/ls2pac/components/SyndeticsConfig";
import React from "react";

export const SyndeticsTermsLink = () => {
  const { syndeticsConfig } = useSyndeticsConfig();

  if (!syndeticsConfig?.active) {
    return null;
  }
  return (
    <Box sx={{ mt: 2 }}>
      <a
        href="https://www.proquest.com/about/terms-and-conditions.html"
        target="_blank"
      >
        Syndetics Terms and Conditions
      </a>
    </Box>
  );
};
